module.exports = __webpack_public_path__ + "static/media/1POLICY17.b66ae3bf.jpg";